/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MemberPreview,
    MemberPreviewFromJSON,
    MemberPreviewFromJSONTyped,
    MemberPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface ElementsGroup
 */
export interface ElementsGroup {
    /**
     * 
     * @type {number}
     * @memberof ElementsGroup
     */
    id: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsGroup
     */
    permissions?: Array<string>;
    /**
     * 
     * @type {Array<MemberPreview>}
     * @memberof ElementsGroup
     */
    readonly membersPreview: Array<MemberPreview>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsGroup
     */
    readonly effectivePermissions: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ElementsGroup
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsGroup
     */
    ldapDn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsGroup
     */
    unixGroupname?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsGroup
     */
    gid?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsGroup
     */
    ldap?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ElementsGroup
     */
    members: Array<number>;
}

export function ElementsGroupFromJSON(json: any): ElementsGroup {
    return ElementsGroupFromJSONTyped(json, false);
}

export function ElementsGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementsGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
        'membersPreview': ((json['members_preview'] as Array<any>).map(MemberPreviewFromJSON)),
        'effectivePermissions': json['effective_permissions'],
        'name': json['name'],
        'ldapDn': !exists(json, 'ldap_dn') ? undefined : json['ldap_dn'],
        'unixGroupname': !exists(json, 'unix_groupname') ? undefined : json['unix_groupname'],
        'gid': !exists(json, 'gid') ? undefined : json['gid'],
        'ldap': !exists(json, 'ldap') ? undefined : json['ldap'],
        'members': json['members'],
    };
}

export function ElementsGroupToJSON(value?: ElementsGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'permissions': value.permissions,
        'name': value.name,
        'ldap_dn': value.ldapDn,
        'unix_groupname': value.unixGroupname,
        'gid': value.gid,
        'ldap': value.ldap,
        'members': value.members,
    };
}


